import React from "react";
import IconsWidget from "@techsoftware/happay-widgets/FontIcon";

export default class Icons extends React.Component {
    render() {
        return <IconsWidget {...this.props} />;
    }
}